import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UserService } from '@app/shared/services/user/user.service';
import * as loginSelectors from './../../../../../root-store/login-store/login.selector';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'checklist-gather',
  templateUrl: './checklist-gather.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryChecklistGatherComponent implements OnInit, OnDestroy {
  @Input() data;
  @Output() moveNextPreviousEvent = new EventEmitter<any>();

  currentUser;
  onBoardingChecklists;
  allHaveOnBoardingStatus = false;
  subscription = new Subscription();

  constructor(private store: Store, private _userService: UserService, private cd: ChangeDetectorRef) {
    this.subscription.add(
      this.store.select(loginSelectors.getCurrentUserDetailsAll).subscribe((user) => {
        this.currentUser = user;
      })
    );
  }

  ngOnInit(): void {
    this.getOnboardingChecklist();
  }

  getOnboardingChecklist() {
    // this.data?.group_name.toLowerCase()
    this.subscription.add(
      this._userService.getOnboardingChecklist('gather', this.data?.user_discovery_path_id).subscribe(
        (res) => {
          this.onBoardingChecklists = [...res];
          this.checkIfAllOnboardingStatusHaveValue();
          this.cd.detectChanges();
        },
        (error: any) => {}
      )
    );
  }

  updateOnboardingChecklist() {
    if (!this.allHaveOnBoardingStatus) return;
    const payload = [];
    this.onBoardingChecklists.forEach((checklist) => {
      checklist.forms.forEach((form) => {
        form.reminders.forEach((remainder) => {
          payload.push({
            vault_user_form_reminder_id: remainder.vault_user_form_reminder_id,
            onboarding_status: remainder.onboarding_status,
          });
        });
      });
    });
    this.subscription.add(
      this._userService.updateOnboardingChecklist(payload).subscribe(
        (res) => {
          this.getOnboardingChecklist();
          this.handleSteps('forward');
        },
        (error: any) => {}
      )
    );
  }

  checkIfAllOnboardingStatusHaveValue() {
    // Check if all onboarding_status have values
    this.allHaveOnBoardingStatus = this.onBoardingChecklists.every((checklist) => {
      return checklist.forms.every((form) => {
        return form.reminders.every((remainder) => {
          return remainder.onboarding_status !== null && remainder.onboarding_status !== undefined;
        });
      });
    });
    this.cd.detectChanges();
  }

  updateChecklist(item, type) {
    item.onboarding_status = type;
    this.checkIfAllOnboardingStatusHaveValue();
    this.cd.detectChanges();
  }

  handleSteps(event) {
    this.moveNextPreviousEvent.emit({ status: event, ...(event == 'forward' && { id: this.data?.id }) });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
